import faq from './faq.json';
import home from './home.json';
import tariffs from './tariffs.json';

export default {
  faq,
  home,
  tariffs,
};
